export default __webpack_public_path__ + "static/media/business.6b73fc60.jpg";